import type { Movie, ThemeCollection } from "@/types/movie";

export const movies: Movie[] = [
  {
    id: "m001",
    title: "沉默的抉择",
    type: "movie",
    year: 2024,
    rating: 8.7,
    region: "中国大陆",
    duration: 128,
    episodes: 0,
    tags: ["伦理", "悬疑", "剧情"],
    director: "顾清野",
    cast: ["林知远", "苏未央", "沈砚清", "周望舒"],
    synopsis:
      "一位坚守原则的检察官在处理一桩看似普通的案件时，逐渐发现真相与身边至亲紧紧纠缠。当职业信念与家庭情感发生正面冲撞，他必须在无人知晓的长夜里做出那个没有人愿意面对的抉择。沉默并非懦弱，而是一场关于良心与责任的漫长拷问。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20lone%20man%20standing%20in%20a%20dim%20courtroom%20corridor%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20scene%20of%20an%20empty%20courtroom%20at%20dusk%20with%20tall%20windows%2C%20deep%20blue%20shadows%20and%20warm%20amber%20light%20beams%2C%20dust%20in%20the%20air%2C%20moody%20atmospheric%20film%20still%2C%20high%20detail%2C%20editorial%20photography%2C%20no%20text%20no%20watermark&width=1920&height=1080&seq=eth-hero-01&orientation=landscape",
    theme: "justice",
    featured: true,
    popularity: 98,
  },
  {
    id: "m002",
    title: "暗流之下",
    type: "tv",
    year: 2024,
    rating: 8.9,
    region: "中国大陆",
    duration: 45,
    episodes: 24,
    tags: ["伦理", "都市", "社会"],
    director: "陆时清",
    cast: ["江照白", "温皖", "程叙", "白宁"],
    synopsis:
      "繁华都市的地下管网里，藏着这座城最不愿被提及的秘密。一群普通人在利益与道义之间反复摇摆，有人守住底线，有人在诱惑中滑向深渊。剧集以群像视角剖开现代都市的复杂肌理，追问每个人心中的那条暗流究竟通向何方。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20rainy%20neon%20city%20street%20seen%20from%20below%2C%20reflections%20on%20wet%20asphalt%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20night%20cityscape%20of%20a%20modern%20metropolis%20with%20glowing%20windows%20and%20wet%20streets%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20light%20rain%2C%20moody%20atmospheric%20film%20still%2C%20high%20detail%2C%20editorial%20photography%2C%20no%20text%20no%20watermark&width=1920&height=1080&seq=eth-hero-02&orientation=landscape",
    theme: "city",
    featured: true,
    popularity: 96,
  },
  {
    id: "m003",
    title: "群山回响",
    type: "movie",
    year: 2023,
    rating: 8.4,
    region: "中国大陆",
    duration: 118,
    episodes: 0,
    tags: ["伦理", "家庭", "剧情"],
    director: "乌兰其木格",
    cast: ["贺兰", "巴特尔", "陈牧", "李夏禾"],
    synopsis:
      "在群山环抱的小村里，一个关于土地、承诺与血脉的故事缓缓展开。父辈固守的家园即将被时代改写，年轻的儿女却在城市与故乡之间找不到归处。连绵的山峦记得每一句誓言，也见证着一家人如何在告别中重新理解彼此。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20misty%20mountain%20ridges%20at%20dawn%20with%20a%20tiny%20lone%20cottage%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-03&orientation=portrait",
    theme: "family",
    popularity: 88,
  },
  {
    id: "m004",
    title: "归途",
    type: "tv",
    year: 2023,
    rating: 8.2,
    region: "中国大陆",
    duration: 42,
    episodes: 20,
    tags: ["伦理", "家庭", "情感"],
    director: "沈曼",
    cast: ["柳青禾", "宋知白", "顾宛", "谭越"],
    synopsis:
      "一次意外让离散多年的亲人重新走进彼此的生活。旧日的误解、未说出口的歉意、被时间掩埋的真相，在重逢的日子里一点点浮出水面。归途很长，长到足以让人学会原谅，也足以让人重新认识什么是家。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20long%20country%20road%20leading%20toward%20a%20warm%20lit%20house%20at%20dusk%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-04&orientation=portrait",
    theme: "family",
    popularity: 84,
  },
  {
    id: "m005",
    title: "第七个证人",
    type: "movie",
    year: 2024,
    rating: 8.6,
    region: "中国大陆",
    duration: 122,
    episodes: 0,
    tags: ["伦理", "悬疑", "剧情"],
    director: "何遇",
    cast: ["裴之", "叶知秋", "闻朝", "苏合"],
    synopsis:
      "一桩悬而未决的旧案在多年后重启，六位证人各执一词，唯独第七个人的证词始终缺席。当律师一步步逼近真相，他发现最难面对的并非谎言，而是每个人都曾以沉默默许过的不公。真相的重量，最终压在了每一个旁观者身上。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20silhouette%20holding%20a%20candle%20in%20a%20dark%20hallway%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-05&orientation=portrait",
    theme: "justice",
    popularity: 94,
  },
  {
    id: "m006",
    title: "暮色边界",
    type: "tv",
    year: 2022,
    rating: 8.0,
    region: "中国香港",
    duration: 44,
    episodes: 18,
    tags: ["伦理", "都市", "情感"],
    director: "岑朗",
    cast: ["何芷晴", "雷颂川", "麦子谦", "温思澜"],
    synopsis:
      "在城市的边缘地带，生活着一群被主流遗忘的人。一位社工试图为他们争取应有的尊严，却发现自己也在道德的天平上反复衡量。暮色之中，边界模糊，善与恶、对与错都不再是非黑即白的命题。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20city%20outskirt%20rooftop%20at%20sunset%20with%20power%20lines%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-06&orientation=portrait",
    theme: "city",
    popularity: 80,
  },
  {
    id: "m007",
    title: "灯塔守护者",
    type: "movie",
    year: 2022,
    rating: 8.5,
    region: "中国大陆",
    duration: 112,
    episodes: 0,
    tags: ["伦理", "剧情", "家庭"],
    director: "海晏",
    cast: ["老罗", "罗小满", "林望", "陈屿"],
    synopsis:
      "一座偏远海岛上的灯塔，守了半个世纪的老人和他多年未见的儿子终于同处一屋。海浪拍打着礁石，也拍打着两代人之间沉默的隔阂。当风暴来临，他们不得不共同面对一段被尘封的往事，以及那句迟到了太久的对不起。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20lighthouse%20on%20a%20rocky%20island%20under%20a%20stormy%20sky%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-07&orientation=portrait",
    theme: "family",
    popularity: 90,
  },
  {
    id: "m008",
    title: "雾中审判",
    type: "tv",
    year: 2024,
    rating: 8.8,
    region: "中国大陆",
    duration: 48,
    episodes: 26,
    tags: ["伦理", "悬疑", "社会"],
    director: "白临川",
    cast: ["谢云归", "陆延", "简宁", "邵屿"],
    synopsis:
      "浓雾笼罩的小城接连发生离奇事件，一位记者与一位年轻法官被卷入其中。舆论、权力与真相交织成一张密不透风的网，每个人都以为自己站在正义一边。当迷雾散去，人们才发现最难审判的，始终是人心。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20foggy%20old%20town%20street%20with%20a%20distant%20lamp%20glow%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20view%20of%20a%20fog%20covered%20old%20town%20with%20traditional%20rooftops%20and%20dim%20street%20lamps%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20moody%20atmospheric%20film%20still%2C%20high%20detail%2C%20editorial%20photography%2C%20no%20text%20no%20watermark&width=1920&height=1080&seq=eth-hero-03&orientation=landscape",
    theme: "justice",
    featured: true,
    popularity: 97,
  },
  {
    id: "m009",
    title: "河流的记忆",
    type: "movie",
    year: 2021,
    rating: 8.1,
    region: "中国大陆",
    duration: 120,
    episodes: 0,
    tags: ["伦理", "剧情", "家庭"],
    director: "江河",
    cast: ["老周", "周渔", "宁婉", "许青"],
    synopsis:
      "一条奔流不息的河，流过一座小城的兴衰，也流过一家人三代人的命运。为了守护祖辈留下的渡口，还是为了生计将它拱手相让，年轻人与长辈之间爆发了激烈的冲突。河水无言，却记得所有人做过的选择。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20wide%20river%20with%20an%20old%20ferry%20boat%20at%20misty%20morning%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-09&orientation=portrait",
    theme: "family",
    popularity: 82,
  },
  {
    id: "m010",
    title: "镜中人",
    type: "tv",
    year: 2023,
    rating: 8.3,
    region: "中国大陆",
    duration: 43,
    episodes: 22,
    tags: ["伦理", "都市", "悬疑"],
    director: "莫语",
    cast: ["程镜", "沈知雨", "陆时", "白洛"],
    synopsis:
      "一位心理咨询师在诊室里遇见了形形色色的来访者，却在一面旧镜子里看见了自己不愿承认的另一面。职业的冷静与内心的暗涌不断拉扯，她渐渐明白，最难治愈的病人，往往正是镜中那个被精心隐藏的自己。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20reflection%20in%20an%20old%20cracked%20mirror%20inside%20a%20calm%20room%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-10&orientation=portrait",
    theme: "city",
    popularity: 86,
  },
  {
    id: "m011",
    title: "冬夜微光",
    type: "movie",
    year: 2023,
    rating: 8.6,
    region: "中国大陆",
    duration: 116,
    episodes: 0,
    tags: ["伦理", "情感", "剧情"],
    director: "雪原",
    cast: ["顾寒", "温以宁", "陆知昼", "安歌"],
    synopsis:
      "雪夜的火车站，一位陌生人递出的一杯热茶，改变了两个疲惫灵魂的轨迹。他们各自背负着无法言说的过往，在短暂的相遇中交换了勇气。当黎明来临，微光不仅照亮了归途，也照亮了重新开始的可能。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20snowy%20train%20station%20at%20night%20with%20a%20single%20warm%20lamp%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-11&orientation=portrait",
    theme: "emotion",
    popularity: 92,
  },
  {
    id: "m012",
    title: "无声的证词",
    type: "tv",
    year: 2024,
    rating: 8.7,
    region: "中国大陆",
    duration: 46,
    episodes: 24,
    tags: ["伦理", "悬疑", "社会"],
    director: "郑泊",
    cast: ["宋亦", "林清嘉", "傅时", "尹夏"],
    synopsis:
      "一名手语翻译志愿者意外卷入一桩没有目击者的案件。听障当事人无法为自己发声，线索在安静的沉默中若隐若现。剧集以声音的缺席为切口，追问当一个人被剥夺了表达的权利时，公平还能否被听见。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20silent%20hands%20raised%20against%20a%20dark%20window%20with%20rain%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-12&orientation=portrait",
    theme: "justice",
    popularity: 93,
  },
  {
    id: "m013",
    title: "尘埃落定时",
    type: "movie",
    year: 2022,
    rating: 8.2,
    region: "中国台湾",
    duration: 124,
    episodes: 0,
    tags: ["伦理", "家庭", "剧情"],
    director: "吴念安",
    cast: ["陈昭", "林宜静", "黄允", "曾乐"],
    synopsis:
      "一座即将被拆除的老宅，牵出尘封多年的家族往事。兄弟姐妹为了遗产争执不下，却在整理遗物时发现了母亲留下的日记。尘埃缓缓落下，那些曾被误解的爱与牺牲，终于在一纸泛黄的笔迹里得到回答。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20old%20wooden%20house%20interior%20with%20sunbeam%20and%20dust%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-13&orientation=portrait",
    theme: "family",
    popularity: 83,
  },
  {
    id: "m014",
    title: "双面人生",
    type: "tv",
    year: 2021,
    rating: 7.9,
    region: "中国大陆",
    duration: 41,
    episodes: 20,
    tags: ["伦理", "都市", "情感"],
    director: "柳向晚",
    cast: ["方迟", "苏念", "陆遥", "简一"],
    synopsis:
      "白天他是人人称羡的模范丈夫与好同事，夜里却过着截然不同的生活。一次意外的泄露让精心维持的两副面孔濒临崩塌。剧集不急于评判，而是缓缓展开一个人如何在欲望与责任之间，把自己困成了牢笼。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20man%20split%20by%20light%20and%20shadow%20in%20a%20modern%20room%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-14&orientation=portrait",
    theme: "city",
    popularity: 78,
  },
  {
    id: "m015",
    title: "槐树下",
    type: "movie",
    year: 2024,
    rating: 8.9,
    region: "中国大陆",
    duration: 130,
    episodes: 0,
    tags: ["伦理", "家庭", "情感"],
    director: "原文",
    cast: ["老原", "原野", "江晚", "沈砚"],
    synopsis:
      "老槐树见证了这个村庄几十年的悲欢离合，也见证了一对父子长久的沉默与隔阂。为了守住祖辈的根，还是为了孩子的未来放手，两代人在树下反复争执。当花开花落几度轮回，他们终于读懂了彼此固执背后深藏的爱。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20large%20old%20pagoda%20tree%20in%20a%20village%20at%20golden%20hour%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20village%20landscape%20at%20golden%20hour%20with%20a%20huge%20old%20tree%2C%20tiled%20rooftops%20and%20amber%20sunlight%2C%20deep%20blue%20shadows%2C%20moody%20atmospheric%20film%20still%2C%20high%20detail%2C%20editorial%20photography%2C%20no%20text%20no%20watermark&width=1920&height=1080&seq=eth-hero-04&orientation=landscape",
    theme: "family",
    featured: true,
    popularity: 99,
  },
  {
    id: "m016",
    title: "晚风知我意",
    type: "tv",
    year: 2023,
    rating: 8.4,
    region: "中国大陆",
    duration: 44,
    episodes: 22,
    tags: ["伦理", "都市", "剧情"],
    director: "顾晚",
    cast: ["南禾", "许知意", "程晚舟", "林之白"],
    synopsis:
      "都市中两个孤独的成年人因一次误会结识，从彼此身上照见了自己长久逃避的责任与牵挂。晚风轻拂，他们在一场又一场的谈话中学会面对家庭、工作与内心真正渴望的取舍。原来懂得自己，才是成年人最难的功课。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20two%20figures%20on%20a%20rooftop%20at%20blue%20hour%20with%20city%20lights%2C%20moody%20atmospheric%20lighting%2C%20deep%20blue%20and%20warm%20amber%20color%20grading%2C%20minimalist%20dramatic%20background%2C%20soft%20glow%2C%20high%20detail%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=900&seq=eth-cover-16&orientation=portrait",
    theme: "emotion",
    popularity: 85,
  },
];

export const themeCollections: ThemeCollection[] = [
  {
    key: "justice",
    name: "正义与良知",
    subtitle: "法庭内外，那些关于原则的抉择",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20scenery%20of%20a%20scales%20of%20justice%20silhouette%20in%20warm%20light%20against%20deep%20blue%20backdrop%2C%20minimal%20dramatic%20composition%2C%20moody%20atmospheric%20photography%2C%20no%20text%20no%20watermark&width=800&height=600&seq=eth-theme-01&orientation=landscape",
  },
  {
    key: "family",
    name: "家庭与血脉",
    subtitle: "关于守护、传承与和解的故事",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20scenery%20of%20a%20cozy%20warm%20lit%20country%20house%20at%20dusk%20among%20hills%2C%20minimal%20dramatic%20composition%2C%20moody%20atmospheric%20photography%2C%20no%20text%20no%20watermark&width=800&height=600&seq=eth-theme-02&orientation=landscape",
  },
  {
    key: "city",
    name: "都市众生相",
    subtitle: "繁华背后，每个人都有自己的暗流",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20scenery%20of%20a%20modern%20city%20skyline%20at%20night%20with%20reflections%20on%20water%2C%20minimal%20dramatic%20composition%2C%20moody%20atmospheric%20photography%2C%20no%20text%20no%20watermark&width=800&height=600&seq=eth-theme-03&orientation=landscape",
  },
  {
    key: "emotion",
    name: "情感与救赎",
    subtitle: "在漫长冬夜里，寻找一束微光",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20scenery%20of%20a%20lone%20warm%20street%20lamp%20glowing%20in%20the%20snow%20at%20night%2C%20minimal%20dramatic%20composition%2C%20moody%20atmospheric%20photography%2C%20no%20text%20no%20watermark&width=800&height=600&seq=eth-theme-04&orientation=landscape",
  },
];

export const allTags: string[] = ["伦理", "都市", "家庭", "悬疑", "剧情", "情感", "社会"];